import { useIntl } from 'react-intl'

import ButtonCinestar from '../../Buttons/ButtonCinestar/ButtonCinestar'
import Icon from '../../Icon/Icon'
import Seat from '../../Seat/Seat'
import Typography from '../../Typography/Typography'

import './TooltipWindow.scss'

const TooltipWindowNew = ({ imgUrl, name, title, subtitle, seatProperties, onClose }) => {
    const intl = useIntl()
    let type = null
    let size = null
    if (name) {
        const typeAndSize = [...name.split('-')]
        type = typeAndSize[0]
        size = typeAndSize[1]
    }

    return (
        <div className="tooltip-window">
            <div className="tooltip-window--image position-relative">
                {type && size && <Seat type={type} size={size} className={'position-absolute start-0 top-0 m-4'} />}

                <Icon
                    name={'cross'}
                    className={'tooltip-window--close position-absolute end-0 top-0 m-4'}
                    style={{ width: '1rem' }}
                    onClick={onClose}
                />
                <img src={imgUrl} />
            </div>

            <div className="tooltip-window--info d-flex flex-column">
                <div className="d-flex flex-column gap-1">
                    <Typography variant={'h2'}>{title}</Typography>
                    <div dangerouslySetInnerHTML={{ __html: subtitle }} />
                </div>
                <div className="border-top border-lighterPrimary opacity-50" />
                <div className="d-flex gap-4">
                    <div className="d-flex flex-column gap-1">
                        {seatProperties?.map((property, index) => (
                            <Typography key={index} variant={'label'} color={'lighterPrimary'}>
                                {property.key}
                            </Typography>
                        ))}
                    </div>

                    <div className="d-flex flex-column gap-1">
                        {seatProperties?.map((property, index) => (
                            <Typography key={index} variant={'label'}>
                                {property.value}
                            </Typography>
                        ))}
                    </div>
                    <div className="d-flex flex-grow-1">
                        <ButtonCinestar
                            variant={'secondary'}
                            iconRight={'cross'}
                            onClick={onClose}
                            className={'tooltip-window--close d-block my-auto ms-auto'}
                        >
                            {intl.formatMessage({ id: `buttons.close` })}
                        </ButtonCinestar>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TooltipWindowNew
